import { render, staticRenderFns } from "./Banners_detail.vue?vue&type=template&id=60f93ea8&"
import script from "./Banners_detail.vue?vue&type=script&lang=js&"
export * from "./Banners_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports